import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    standalone: false
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(public _router: Router) {}

  @ViewChild('layoutHeader') layoutHeader?: ElementRef<HTMLElement>;

  isNavBarOpen: boolean = false;
  isHeaderStuck = false;

  /** When false, `.home-footer` on Webinar-rooms supplies scroll clearance with matching gradient */
  needsFooterBottomClearance = true;

  private routerSub?: Subscription;
  private headerResizeObserver?: ResizeObserver;

  ngOnInit(): void {
    this.updateSurfaceFlags(this._router.url);
    this.routerSub = this._router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.updateSurfaceFlags(this._router.url));
  }

  ngAfterViewInit(): void {
    this.syncHeaderOffset();
    const header = this.layoutHeader?.nativeElement;
    if (header && typeof ResizeObserver !== 'undefined') {
      this.headerResizeObserver = new ResizeObserver(() => this.syncHeaderOffset());
      this.headerResizeObserver.observe(header);
    }
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
    this.headerResizeObserver?.disconnect();
    document.body.classList.remove('host-theme');
  }

  private updateSurfaceFlags(rawUrl: string): void {
    this.updateFooterClearanceFlag(rawUrl);
    this.updateHostTheme(rawUrl);
  }

  private updateFooterClearanceFlag(rawUrl: string): void {
    const path = (rawUrl.split(/[?#]/)[0] || '').replace(/\/+$/, '') || '/';
    this.needsFooterBottomClearance = path !== '/Webinar-rooms' && path !== '/' && path !== '';
  }

  private updateHostTheme(rawUrl: string): void {
    const path = (rawUrl.split(/[?#]/)[0] || '').replace(/\/+$/, '') || '/';
    const isHostSurface =
      path === '/SignUpHost' ||
      path === '/HostPortal' ||
      path === '/MyStats' ||
      path === '/create-webinar' ||
      path.startsWith('/edit-webinar');
    document.body.classList.toggle('host-theme', isHostSurface);
  }

  private syncHeaderOffset() {
    const height = this.layoutHeader?.nativeElement?.offsetHeight;
    if (height) {
      document.documentElement.style.setProperty('--app-header-offset', `${height}px`);
    }
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.isHeaderStuck = (window.scrollY || 0) > 8;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.syncHeaderOffset();
    if (window.innerWidth < 767)
      this.isNavBarOpen = true;
    else
      this.isNavBarOpen = false;
  }

}
